import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { WcGridComponent } from '../../components/wc-grid/wc-grid.component';

@Component({
  selector: 'group-record-access-sync',
  standalone: false,
  encapsulation: ViewEncapsulation.None,
  templateUrl: './group-record-access-sync.component.html',
  styleUrl: './group-record-access-sync.component.css'
})
export class GroupRecordAccessSyncComponent {
  @ViewChild('grid') grid?: WcGridComponent;

  reload(): void {
    this.grid?.reload(1);
  }
}
